import React, { Component, Fragment } from "react";
import Breadcrumb from "../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";

import {
  getSingleMonthlyLoanCashOutRedux,
  getSingleMonthlyLoanCashInRedux,
} from "../../../actions/index";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import "./loan.css";

export class MonthlyExpenseByMonth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      toggleModal: true,
      employee: null,
    };
  }

  componentDidMount = async () => {
    const [type, month] = this.props.match.params.month.split("-");
    if (type === "expense") {
      this.props.getSingleMonthlyLoanCashOutRedux(month, "LOAN");
    } else {
      this.props.getSingleMonthlyLoanCashInRedux(month, "LOAN");
    }
  };

  startToggleModal = async (employeeObj) => {
    if (employeeObj == null) {
      this.setState({ toggleModal: !this.state.toggleModal, employee: null });
    } else {
      this.setState({
        toggleModal: !this.state.toggleModal,
        employee: employeeObj,
      });
    }
  };

  render() {
    const { open } = this.state;
    const { allExpenses, allCashIns } = this.props;
    const [type, month] = this.props.match.params.month.split("-");

    let totalCashIn = 0;
    let totalCashOut = 0;
    allExpenses.map((expense) => {
      totalCashOut += parseInt(expense.amount);
    });
    allCashIns.map((cashIn) => {
      totalCashIn += parseInt(cashIn.amount);
    });
    console.log(this.props);
    return (
      <Fragment>
        <Breadcrumb
          title={type === "expense" ? "Cash Out" : "Cash In"}
          parent="Loan"
        />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid ln-page">
          <div className="row">
            <div className="col-sm-12">
              <div className="card ln-card">
                <div className="card-header ln-card-header">
                  <h5 className="ln-card-title">
                    <i className="icofont-calendar ln-card-icon"></i>
                    {month} (LOAN)
                  </h5>
                </div>
                <div className="card-body">
                  <div className="ln-total-chip">
                    <span className="ln-total-chip-label ln-stamp-font">
                      {type === "expense" ? "Cash Out Total" : "Cash In Total"}
                    </span>
                    <span className="ln-total-chip-value">
                      {type === "expense" ? totalCashOut : totalCashIn}Tk
                    </span>
                  </div>
                  <div className="clearfix"></div>
                  <div id="basicScenario" className="product-physical">
                    <div className="ln-table-wrap">
                      <table className="table ln-table">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">Date</th>
                            <th scope="col">Category</th>
                            <th scope="col">Sub Category</th>
                            <th scope="col">Note</th>
                            <th scope="col">Amount</th>
                          </tr>
                        </thead>
                        {type === "expense" ? (
                          <tbody>
                            {this.props.allExpenses.length === 0 ? (
                              <tr>
                                <td colSpan={6} className="ln-empty">No entries for this month.</td>
                              </tr>
                            ) : (
                              this.props.allExpenses.map((expense, index) => (
                                <tr key={index}>
                                  <th scope="row">{index + 1}</th>
                                  <td>{expense.date}</td>
                                  <td>
                                    <span className="ln-badge ln-badge--purple">{expense.category}</span>
                                  </td>
                                  <td>{String(expense.subCategory || "").replace(/^undefined-/, "")}</td>
                                  <td>{expense.note}</td>
                                  <td>
                                    <span className="ln-amount-pill">{expense.amount}Tk</span>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        ) : (
                          <tbody>
                            {this.props.allCashIns.length === 0 ? (
                              <tr>
                                <td colSpan={6} className="ln-empty">No entries for this month.</td>
                              </tr>
                            ) : (
                              this.props.allCashIns.map((expense, index) => (
                                <tr key={index}>
                                  <th scope="row">{index + 1}</th>
                                  <td>{expense.date}</td>
                                  <td>
                                    <span className="ln-badge ln-badge--purple">{expense.category}</span>
                                  </td>
                                  <td>{String(expense.subCategory || "").replace(/^undefined-/, "")}</td>
                                  <td>{expense.note}</td>
                                  <td>
                                    <span className="ln-amount-pill">{expense.amount}Tk</span>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        )}
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allExpenses: state.loans.monthlyCashOuts,
    allCashIns: state.loans.monthlyCashIns,
  };
};

export default connect(mapStateToProps, {
  getSingleMonthlyLoanCashInRedux,
  getSingleMonthlyLoanCashOutRedux,
})(MonthlyExpenseByMonth);
